import {
  updateSelectDateTime,
  getAllBranch,
  getUsersTechnician,
  getUsersSale,
  updatePageLoadingApi,
  getAllUserSales,
  getAdjustmentTypes,
  resetReportFilters
} from '@slice/select.slice';
import { AutoComplete, Button, Checkbox, Input, Select, Tooltip, message } from 'antd';
import { RootState } from 'app/store';
import { IOptionData } from 'models/OptionData';
import React, { useMemo, useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import MultipleSelect from './MultipleSelect';
import SingleSelect from './SingleSelect';
import { getAllTypeOrders } from '@slice/createOrder.slice';
import { ThunkDispatch } from 'redux-thunk';
import { Item } from 'devextreme-react/cjs/data-grid';
import RangeDateJs from '@components/rangeDateTimeJs';
import Helpers from 'helpers/Helpers';
import {
  dataCoopType,
  dataOptionInput,
  dataOptionInputTime,
  dataHTTT,
  dataOptionCompanyName,
  dataOptionAfterComplete,
  dataTypeBranch,
  dataBlock,
  dataSearchWhatCustomer,
  dataOperateCollected,
  dataAccountantCollected,
  dataOptionInputV1,
  dataOptionInvoice,
  dataOptionTransaction,
  dataCSKHType,
  dataCSKHSearchOption
} from './DataType';

import { IAccount } from '@models/Account';
import { ISelectOption } from 'global/Global';
import AuthServiceApi from 'apis/api/Auth';
import { FilterOutlined, SearchOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { getAllUser, getStateTech, getTypeAndState } from '@slice/adminConfig.slice';
const InputSearchDefault: any = styled(Select)``;

const { Option } = Select;
export enum EModePanelSelect {
  Staff = 'Staff',
  Order = 'Order',
  Customer = 'Customer',
  Sell = 'Sell',
  Tech = 'Tech',
  TechV2 = 'TechV2',
  Operating = 'Operating',
  Accountant = 'Accountant',
  Stock = 'Stock',
  Category = 'Category',
  Branch = 'Branch',
  BranchV2 = 'BranchV2',
  Status = 'Status',
  CompanyName = 'CompanyName',
  TypeCompany = 'TypeCompany',
  CoopType = 'CoopType',
  CoopTypeV2 = 'CoopTypeV2',
  Time = 'Time',
  PaymentMethod = 'PaymentMethod',
  ListSales = 'ListSales',
  ListSalesV2 = 'ListSalesV2',
  ListSalesV3 = 'ListSalesV3',
  TypeBranch = 'TypeBranch',
  IsBlock = 'IsBlock',
  OperateCollected = 'OperateCollected',
  AccountantCollected = 'AccountantCollected',
  WalletState = 'WalletState',
  WalletStateTech = 'WalletStateTech',
  WalletType = 'WalletType',
  AdjustmentTypes = 'AdjustmentTypes',
  SupportBranch = 'SupportBranch',
  SupportState = 'SupportState',
  Sender = 'Sender', // Người gửi
  Receiver = 'Receiver' // Người nhận
}

// 1. Đưa các loại checkType không muốn hiển thị Input vào một mảng
const hiddenInputTypes = [
  'tongquanKD',
  'tongquan',
  'khachhang',
  'theodoithutien',
  'sim',
  'hoadon',
  'vikythuat',
  'khokythuat',
  'phieuhotro',
  'thongkehetphi' // ThongKeHetPhi: xoá được nếu trang "Thống kê xe hết phí ở đại lý" không dùng SelectPanel nữa
];

export interface ICallBackEvents {
  onClick?: (e?: any) => any;
  callBackOrdersReport?: (customInputValue: string, selectedOption: string, sales?: any, httt?: any) => any;
  callBackTechReport?: (customInputValue: string, selectedOption: string, sales?: any, httt?: any) => any;
  callBackWalletTech?: (state: number) => any;
  callBackWareHouseReport?: (customInputValue: string, selectedOption: string, sales?: any, httt?: any) => any;
  callBackCustomer?: (customInputValue: string, selectedOption: string, sales?: any, httt?: any) => any;
  callBackTransaction?: (value: any, selectedOption: string) => any;
  callBackInvoice?: (customInputValue: string, selectedOption: string) => any;
  callBackSim?: (customInputValue: string, selectedOption: string, sales?: any, httt?: any) => any;
  callBackCareReport?: (customInputValue: string, selectedOption: string, sales?: any, httt?: any) => any;
  callBackTypeSelect?: (note?: any) => any;
  callBackOrderStatus?: (note?: any) => any;
  callBackViewAll?: () => any;
  callBackTicketReport?: (searchValue: string, searchOption: any) => any;
  // ThongKeHetPhi: callback bấm nút "Xem" khi có prop dealerStatisticFilter - xoá được cùng lúc với
  // các đoạn khác đánh dấu "ThongKeHetPhi" trong file này nếu trang đó không dùng SelectPanel nữa
  callBackDealerStatisticFilter?: () => any;
}

// ThongKeHetPhi: props cho filter riêng của trang "Thống kê xe hết phí ở đại lý"
// (Khu vực/Server/Loại thiết bị đều multi-select độc lập + ô tìm đại lý có autocomplete gọi API riêng,
// không dùng được các nhánh EModePanelSelect có sẵn vì cơ chế multi-select gốc chỉ hỗ trợ 1 nhóm dùng chung).
// Xoá được an toàn: interface này + prop dealerStatisticFilter dưới đây + callBackDealerStatisticFilter
// + đoạn render JSX + đoạn gọi trong handleViewButton, đều đã đánh dấu "ThongKeHetPhi".
export interface IDealerStatisticFilterProps {
  regionOptions: { value: number; label: string }[];
  serverOptions: { value: number; label: string }[];
  deviceTypeOptions: { value: number; label: string }[];
  regionValue: number[];
  serverValue: number[];
  deviceTypeValue: number[];
  onRegionChange: (value: number[]) => void;
  onServerChange: (value: number[]) => void;
  onDeviceTypeChange: (value: number[]) => void;
  dealerSearchValue: string;
  dealerSearchOptions: { name: string; normalize: string }[];
  onDealerSearch: (keyword: string) => void;
  onDealerSelect: (name: string, normalize?: string) => void;
}

interface SelectPanelProps {
  isMultipleSelect?: boolean;
  isHiddenDefaultSelect?: boolean;
  isAllOption?: boolean;
  checkType?: string;
  allowHTTT?: boolean;
  allowSelect?: boolean;
  checkSelect?: boolean; // nếu dùng thì cấu hình buộc chọn option trước khi thao tác callback!!
  type?: EModePanelSelect[];
  callBackEvents?: ICallBackEvents;
  limitTimeRange?: number;
  typeKT?: boolean;
  isMutipleOrder?: any;
  hiddenTime?: any;
  // hiddenTime + keepTimeWhenHidden: ẩn ô ngày bằng CSS thay vì bỏ hẳn -> giữ khoảng ngày đã chọn.
  // RangeDateJs mỗi lần dựng lại sẽ về khoảng mặc định và báo lên store (ghi đè ngày đã chọn).
  // Dùng khi 1 trang bật / tắt ô ngày qua lại (vd Quản lý phiếu: tab Lịch sử có ngày, tab Danh sách không).
  keepTimeWhenHidden?: boolean;

  isDisableConfirm?: any;
  selectedRowKeys?: any;
  showMoney?: any;
  handleOpenModal?: any;

  searchOptionList?: { value: number; label: string; placeholder?: string }[];
  searchOptionValue?: number;
  onSearchOptionChange?: (value: number) => void;
  searchValue?: string;
  onSearchValueChange?: (value: string) => void;
  searchValueSelectOptions?: { value: string; label: string }[];

  supportBranchOptions?: { value: string; label: string }[];
  supportTagOptions?: { value: number | string; label: string }[];

  // ThongKeHetPhi: xoá được cùng lúc với IDealerStatisticFilterProps ở trên
  dealerStatisticFilter?: IDealerStatisticFilterProps;
}

export const SelectPanel: React.FC<SelectPanelProps> = ({
  type,
  checkType,
  allowHTTT,
  isMultipleSelect,
  isHiddenDefaultSelect,
  checkSelect,
  isAllOption,
  callBackEvents,
  allowSelect,
  limitTimeRange,
  typeKT,
  isMutipleOrder,
  hiddenTime,
  keepTimeWhenHidden = false,

  isDisableConfirm,
  selectedRowKeys,
  showMoney,
  handleOpenModal,

  searchOptionList,
  searchOptionValue,
  onSearchOptionChange,
  searchValue,
  onSearchValueChange,
  searchValueSelectOptions,
  supportBranchOptions,
  supportTagOptions,
  dealerStatisticFilter // ThongKeHetPhi: xoá được cùng lúc với các đoạn khác đánh dấu "ThongKeHetPhi"
}) => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const loadedDataCreate = useSelector((state: RootState) => state.createOrder.loadedData);
  const loadedDataSelect = useSelector((state: RootState) => state.select.loadedData);
  // const usersSale = useSelector((state: RootState) => state.select.usersSale);
  const account = useSelector((state: RootState) => state.user.account);
  const loadedData = useSelector((state: RootState) => state.admin.loadedData);
  const data = useSelector((state: RootState) => state.admin.allUser);
  const dataAccountant = useSelector((state: RootState) => state.admin.allUserAccountant);
  const dataSales = useSelector((state: RootState) => state.admin.allUserSales);
  const dataOperating = useSelector((state: RootState) => state.admin.allUserOperating);
  const [checkedSixMonth, setCheckedSixMonth] = useState<boolean>(false);

  useEffect(() => {
    dispatch(resetReportFilters());
  }, []); // mount lần đầu của mỗi trang report

  useEffect(() => {
    // ThongKeHetPhi: trang này chỉ dùng dealerStatisticFilter (Đại lý/Khu vực/Server/Loại thiết bị,
    // đã tự fetch riêng qua getListRegion/getListServer/getListDeviceType) - không dùng bất kỳ dữ liệu
    // nào bên dưới (chi nhánh, NV kỹ thuật, NV kinh doanh, loại đơn, ví,...) nên bỏ qua để khỏi gọi
    // thừa ~9 API mỗi lần mở trang. Xoá điều kiện này nếu sau này trang dùng thêm dữ liệu chung.
    if (checkType === 'thongkehetphi') return;

    if (!loadedDataCreate.typeOrderLoaded) dispatch(getAllBranch());
    if (!loadedDataSelect.techStaffLoaded) dispatch(getUsersTechnician());
    if (!loadedDataSelect.adjustmentTypesLoaded) dispatch(getAdjustmentTypes());
    if (!loadedDataCreate.typeOrderLoaded) dispatch(getAllTypeOrders());
    if (!loadedDataSelect.saleStaffLoaded) dispatch(getUsersSale());
    if (!loadedData.AllUserLoaded) dispatch(getAllUser()); // tạo đơn lấy all dữ liệu all User
    if (!loadedData.AllUserSalesLoaded) dispatch(getAllUserSales()); // tạo đơn lấy all dữ liệu all User Sales
    if (!loadedData.walletListLoaded) dispatch(getTypeAndState()); // tạo đơn lấy all dữ liệu all User Sales
    if (!loadedData.walletTechListLoaded) dispatch(getStateTech()); // tạo đơn lấy all dữ liệu all User Sales
  }, []);

  // useEffect(() => {
  //   !loadedDataSelect.salesListLoaded && dispatch(getAllUserSales());
  // }, []);

  // 2. Kiểm tra xem có nên render Input không (Loại bỏ 'congno' khỏi danh sách ẩn)
  const shouldShowInput = !hiddenInputTypes.includes(checkType);

  // 3. Tính toán width động
  const inputWidth = ['congno', 'theodon', 'quanlyphieu'].includes(checkType) ? '350px' : '125px';

  const { t } = useTranslation();

  const staffMultipleSelected = useSelector((state: RootState) => state.select.selectedMultipleStaff);
  const stockMultipleSelected = useSelector((state: RootState) => state.select.selectedMultipleStock);
  const customerMultipleSelected = useSelector((state: RootState) => state.select.selectedMultipleCustomer);
  const categoryMultipleSelected = useSelector((state: RootState) => state.select.selectedMultipleCategory);
  const techs = useSelector((state: RootState) => state.select.techSelectData);
  const adjustmentTypes = useSelector((state: RootState) => state.select.adjustmentTypesSelectData);
  const stocks = useSelector((state: RootState) => state.select.stockSelectData);
  const customer = useSelector((state: RootState) => state.select.customerSelectData);
  const walletListState = useSelector((state: RootState) => state.admin.walletListState);
  const walletListType = useSelector((state: RootState) => state.admin.walletListType);
  const walletListStateTech = useSelector((state: RootState) => state.admin.walletListStateTech);
  const branch = useSelector((state: RootState) => state.select.branchSelectData);
  const listTechBranch = useSelector((state: RootState) => state.select.listTechBranch);
  const listOperatingBranch = useSelector((state: RootState) => state.select.listOperatingBranch);
  const listAccountantBranch = useSelector((state: RootState) => state.select.listAccountantBranch);
  const category = useSelector((state: RootState) => state.production.productCateData);
  const order = useSelector((state: RootState) => state.createOrder.typeOrderData);

  const orderArray = useMemo(() => {
    return order.filter(e => {
      if (checkType === 'kinhdoanh') {
        if (e.label !== 'Thu phí' && e.label !== 'Sửa chữa' && e.label !== 'Bảo hành' && e.label !== 'Tháo - Lắp lại') {
          return true;
        }
        // eslint-disable-next-line array-callback-return
        return;
      }

      if (checkType === 'cskh') {
        if (
          // e.label !== 'Hàng gửi' &&
          e.label !== 'Lắp mới' &&
          e.label !== 'Thu đổi' &&
          e.label !== 'ĐL lắp giùm' &&
          e.label !== 'Lắp giùm ĐL'
        ) {
          return true;
        }
        // eslint-disable-next-line array-callback-return
        return;
      }
      if (checkType === 'kythuat' || checkType === 'dieuhanh') {
        if (e.label !== 'ĐL lắp giùm') {
          return true;
        }
        // eslint-disable-next-line array-callback-return
        return;
      }
      return true;
    });
  }, [order, checkType]);

  const [multipleSelectValue, setMultipleSelectValue] = useState<Array<IOptionData>>([]);
  const [customInputValue, setCustomInputValue] = useState<string>('');
  const [customerInputValue, setCustomerInputValue] = useState<string>('');
  const [cskhInputValue, setCSKHInputValue] = useState<string>('');
  const [transactionInputValue, setTransactionInputValue] = useState<string>('');
  const [simInputValue, setSimInputValue] = useState<string>('');

  const [customerCustomInputValue, setCustomerCustomInputValue] = useState<string>('');
  const [soHoaDonInputValue, setSoHoaDonInputValue] = useState<string>('');
  const [selectedOption, setSelectedOption] = useState<string>('OrderId'); // Mặc định chọn mã đơn hàng
  const [selectedOptionV1, setSelectedOptionV1] = useState<string>('invoiceNo'); // Mặc định chọn số hóa đơn
  const [selectedOptionV4, setSelectedOptionV4] = useState<string>('ProductCode'); // Mặc định chọn số hóa đơn
  const [selectedOptionV2, setSelectedOptionV2] = useState<any>(5); // Mặc định chọn mã đơn hàng
  const [selectedOptionCSKH, setSelectedOptionCSKH] = useState<any>(-1); // Mặc định tìm tất cả (mã API GetForInner)
  const [selectedOptionV3, setSelectedOptionV3] = useState<any>(2); // Mặc định chọn ngày tháng

  const [statusOptions, setStatusOptions] = useState<any[]>([]);

  useMemo(() => {
    if (checkType === 'cskh') {
      return setStatusOptions([
        // { label: t('OrganizedSales.OrderManager.TabName.WaitApproveOrder'), value: 'New', color: '#F39C12' },
        { label: t('OrganizedSales.OrderManager.TabName.InProcessOrder'), value: 'Processing', color: '#006c87' },
        { label: t('OrganizedSales.OrderManager.TabName.HoldOnOrder'), value: 'Pending', color: '#979797' },
        { label: t('OrganizedSales.OrderManager.TabName.CompleteOrder'), value: 'Complete', color: '#008000' },
        { label: t('OrganizedSales.OrderManager.TabName.CancelOrder'), value: 'Cancel', color: '#f50815' },
        // { label: t('OrganizedSales.OrderManager.TabName.DeclineOrder'), value: 'NotApproved', color: '#b06f09' },
        { label: t('OrganizedSales.OrderManager.TabName.Assigned'), value: 'Assigned', color: '#00BFFF' },
        // { label: t('OrganizedSales.OrderManager.TabName.WaitEnter'), value: '8', color: '#0069cb' },
        // { label: t('OrganizedSales.OrderManager.TabName.WaitRepair'), value: '9', color: '#0069cb' },
        // { label: t('OrganizedSales.OrderManager.TabName.ConfirmShip'), value: '10', color: '#db856c' },
        // { label: t('OrganizedSales.OrderManager.TabName.WaitShip'), value: '11', color: '#6974a0' },
        { label: t('OrganizedSales.OrderManager.TabName.Approved'), value: 'Approved', color: '#6c0082' }
      ]);
    } else if (typeKT) {
      return setStatusOptions([
        { label: t('OrganizedSales.OrderManager.TabName.CompleteOrder'), value: 'Complete', color: '#008000' },
        { label: t('OrganizedSales.OrderManager.TabName.CancelOrder'), value: 'Cancel', color: '#f50815' }
      ]);
    } else {
      return setStatusOptions([
        { label: t('OrganizedSales.OrderManager.TabName.WaitApproveOrder'), value: 'New', color: '#F39C12' },
        { label: t('OrganizedSales.OrderManager.TabName.InProcessOrder'), value: 'Processing', color: '#006c87' },
        { label: t('OrganizedSales.OrderManager.TabName.HoldOnOrder'), value: 'Pending', color: '#979797' },
        { label: t('OrganizedSales.OrderManager.TabName.CompleteOrder'), value: 'Complete', color: '#008000' },
        { label: t('OrganizedSales.OrderManager.TabName.CancelOrder'), value: 'Cancel', color: '#f50815' },
        { label: t('OrganizedSales.OrderManager.TabName.DeclineOrder'), value: 'NotApproved', color: '#b06f09' },
        { label: t('OrganizedSales.OrderManager.TabName.Assigned'), value: 'Assigned', color: '#00BFFF' }
        // { label: t('OrganizedSales.OrderManager.TabName.WaitEnter'), value: '8', color: '#0069cb' },
        // { label: t('OrganizedSales.OrderManager.TabName.WaitRepair'), value: '9', color: '#0069cb' },
        // { label: t('OrganizedSales.OrderManager.TabName.ConfirmShip'), value: '10', color: '#db856c' },
        // { label: t('OrganizedSales.OrderManager.TabName.WaitShip'), value: '11', color: '#6974a0' },
        // { label: t('OrganizedSales.OrderManager.TabName.Approved'), value: 'Approved', color: '#6c0082' }
      ]);
    }
  }, [checkType, t]);

  // const removeDupliates = _check => {
  //   const uniqueType = Array.from(new Set(_check.map(item => item.type))).map(type => {
  //     return _check.find(item => item.type === type) as Item;
  //   });
  //   return uniqueType;
  // };

  const handleMultipleSelectChange = (value: Array<IOptionData>) => {
    setMultipleSelectValue(value);
  };

  const handleCustomInputChange = (value: string) => {
    setCustomInputValue(value);
  };

  const handleCustomerInputChange = (value: string) => {
    setCustomerInputValue(value);
  };

  const handleCSKHInputChange = (value: string) => {
    setCSKHInputValue(value);
  };

  const handleTransactionInputChange = (value: string) => {
    setTransactionInputValue(value);
  };

  const handleSimInputChange = (value: string) => {
    setSimInputValue(value);
  };

  const handleCustomerCustomInputChange = (value: string) => {
    setCustomerCustomInputValue(value);
  };

  const handleSoHoaDonInputChange = (value: string) => {
    setSoHoaDonInputValue(value);
  };

  const onSelectDateSearch = useCallback((value: any, stringValue?: string[], isTrueFormat?: boolean) => {
    if (stringValue) {
      const timeFormat = isTrueFormat ? value : Helpers.FormatTimeToISOStringSave(value);
      console.log(
        'range time save',
        // props.limitTimeRange,
        // preSelectDate5,
        // preSelectDate31,
        value[0],
        value[1],
        timeFormat[0],
        timeFormat[1]
      );
      dispatch(
        updateSelectDateTime({
          beginTime: timeFormat[0],
          endTime: timeFormat[1]
        })
      );
    }
  }, []);

  const multipleValue = useMemo<Array<IOptionData>>(() => {
    // console.log(staffMultipleSelected);
    if (
      type.includes(EModePanelSelect.Staff) ||
      type.includes(EModePanelSelect.Sell) ||
      type.includes(EModePanelSelect.Operating) ||
      type.includes(EModePanelSelect.Accountant) ||
      type.includes(EModePanelSelect.Tech) ||
      type.includes(EModePanelSelect.TechV2)
    ) {
      return staffMultipleSelected;
    } else if (type.includes(EModePanelSelect.Stock)) {
      return stockMultipleSelected;
    } else if (type.includes(EModePanelSelect.Customer)) {
      return customerMultipleSelected;
    } else if (type.includes(EModePanelSelect.Category)) {
      return categoryMultipleSelected;
    } else {
      return [];
    }
  }, [type, stockMultipleSelected, customerMultipleSelected, staffMultipleSelected, categoryMultipleSelected]);

  const selectBefore = useMemo(() => {
    return (
      <Select style={{ width: '130px' }} defaultValue={dataOptionInput[0].value} onChange={setSelectedOption}>
        {dataOptionInput.map(item => (
          <Select.Option label={item.label} value={item.value} key={item.value}>
            {item.label}
          </Select.Option>
        ))}
      </Select>
    );
  }, [dataOptionInput]);

  const selectBeforeV1 = useMemo(() => {
    return (
      <Select style={{ width: '130px' }} defaultValue={dataOptionInputV1[0].value} onChange={setSelectedOptionV1}>
        {dataOptionInputV1.map(item => (
          <Select.Option label={item.label} value={item.value} key={item.value}>
            {item.label}
          </Select.Option>
        ))}
      </Select>
    );
  }, [dataOptionInputV1]);

  const selectBeforeV2 = useMemo(() => {
    return (
      <Select style={{ width: '130px' }} defaultValue={dataSearchWhatCustomer[4].value} onChange={setSelectedOptionV2}>
        {dataSearchWhatCustomer.map(item => (
          <Select.Option label={item.label} value={item.value} key={item.value}>
            {item.label}
          </Select.Option>
        ))}
      </Select>
    );
  }, [dataSearchWhatCustomer]);

  const selectBeforeCSKH = useMemo(() => {
    return (
      <Select style={{ width: '130px' }} defaultValue={dataCSKHSearchOption[0].value} onChange={setSelectedOptionCSKH}>
        {dataCSKHSearchOption.map(item => (
          <Select.Option label={item.label} value={item.value} key={item.value}>
            {item.label}
          </Select.Option>
        ))}
      </Select>
    );
  }, [dataCSKHSearchOption]);

  const selectBeforeV4 = useMemo(() => {
    return (
      <Select style={{ width: '130px' }} defaultValue={dataOptionTransaction[0].value} onChange={setSelectedOptionV4}>
        {dataOptionTransaction.map(item => (
          <Select.Option label={item.label} value={item.value} key={item.value}>
            {item.label}
          </Select.Option>
        ))}
      </Select>
    );
  }, [dataOptionTransaction]);

  const handleViewButton = () => {
    if (checkSelect) {
      message.error(t('Xử lý check trước đã!'));
      return;
    }

    // báo cáo theo đơn hàng
    if (callBackEvents.callBackOrdersReport) {
      callBackEvents.callBackOrdersReport(
        selectedOption === 'OrderId' ? customInputValue : customerCustomInputValue,
        selectedOption
      );
    }

    if (callBackEvents.callBackCustomer) {
      callBackEvents.callBackCustomer(customerInputValue, selectedOptionV2);
    }

    if (callBackEvents.callBackTransaction) {
      callBackEvents.callBackTransaction(transactionInputValue, selectedOptionV4);
    }

    if (callBackEvents.callBackInvoice) {
      callBackEvents.callBackInvoice(
        selectedOptionV1 === 'orderCode'
          ? customInputValue
          : selectedOptionV1 === 'invoiceNo'
          ? soHoaDonInputValue
          : customerCustomInputValue,
        selectedOptionV1
      );
    }

    if (callBackEvents.callBackSim) {
      callBackEvents.callBackSim(simInputValue, selectedOptionV3);
    }
    if (callBackEvents.callBackTechReport) {
      callBackEvents.callBackTechReport(
        selectedOption === 'OrderId' ? customInputValue : customerCustomInputValue,
        selectedOption
      );
    }
    if (callBackEvents.callBackWareHouseReport) {
      callBackEvents.callBackWareHouseReport(
        selectedOption === 'OrderId' ? customInputValue : customerCustomInputValue,
        selectedOption
      );
    }
    if (callBackEvents.callBackCareReport) {
      callBackEvents.callBackCareReport(
        selectedOption === 'OrderId' ? customInputValue : customerCustomInputValue,
        selectedOption
      );
    }

    if (callBackEvents.callBackTicketReport) {
      callBackEvents.callBackTicketReport(cskhInputValue, selectedOptionCSKH);
    }

    // ThongKeHetPhi: xoá được cùng lúc với các đoạn khác đánh dấu "ThongKeHetPhi"
    if (callBackEvents.callBackDealerStatisticFilter) {
      callBackEvents.callBackDealerStatisticFilter();
    }
  };

  const renderDateTimeRangePicker = useMemo(() => {
    return (
      <>
        {dealerStatisticFilter ? (
          <div className="flex flex-col gap-1">
            <span className="text-xs font-semibold flex !flex-col invisible">Tìm theo khu vực</span>
            <RangeDateJs
              checkType={checkType}
              limitTimeRange={limitTimeRange || 31}
              onSelectDateChange={(date, stringDate) => onSelectDateSearch(date, stringDate)}

              // disabled={true}
            />
          </div>
        ) : (
          <RangeDateJs
            checkType={checkType}
            limitTimeRange={limitTimeRange || 31}
            onSelectDateChange={(date, stringDate) => onSelectDateSearch(date, stringDate)}

            // disabled={true}
          />
        )}
      </>
    );
  }, [limitTimeRange, checkType, dealerStatisticFilter]);

  return (
    <div
      // className="flex flex-col space-x-0 lg:flex-row space-y-2 lg:space-y-0 lg:space-x-2 relative mt-4"
      className={'lg:flex-row lg:space-y-0 lg:space-x-2 flex flex-col space-x-2  space-y-2 relative items-end'}
    >
      {/* phần select 1 */}
      <div className="flex flex-row space-x-2 lg:w-fit flex-wrap">
        {type.map(selectedType => {
          // Update optionsData based on selectedType
          let updatedOptionsData: Array<IOptionData> = [];

          if (selectedType === EModePanelSelect.Tech) {
            // Tạo một biến tạm để xử lý logic lọc branch như bạn muốn log
            let filteredData = [];

            if (listTechBranch && listTechBranch.length > 0) {
              // CLONE MẢNG Ở ĐÂY để tránh lỗi unshift
              filteredData = [...listTechBranch];
            } else {
              filteredData = data
                .filter(item => !item.isLocked && item.role === 'Technician')
                .map(item => ({ value: item.username, label: item.username }))
                .sort((a, b) => a.value.localeCompare(b.value, 'vi', { sensitivity: 'variant', caseFirst: 'upper' }));
            }

            updatedOptionsData = filteredData;
          } else if (selectedType === EModePanelSelect.TechV2) {
            updatedOptionsData = data
              .filter(item => !item.isLocked && item.role === 'Technician')
              .map(item => ({ value: item.username, label: item.username }))
              .sort((a, b) => a.value.localeCompare(b.value, 'vi', { sensitivity: 'variant', caseFirst: 'upper' }));
          } else if (selectedType === EModePanelSelect.Operating) {
            let filteredData = [];

            if (listOperatingBranch && listOperatingBranch.length > 0) {
              // CLONE MẢNG Ở ĐÂY để tránh lỗi unshift
              filteredData = [...listOperatingBranch];
            } else {
              filteredData = dataOperating
                .filter(item => !item.isLocked)
                .map(item => ({ value: item.username, label: item.username }))
                .sort((a, b) => a.value.localeCompare(b.value, 'vi', { sensitivity: 'variant', caseFirst: 'upper' }));
            }

            updatedOptionsData = filteredData;
          } else if (selectedType === EModePanelSelect.Accountant) {
            let filteredData = [];

            if (listAccountantBranch && listAccountantBranch.length > 0) {
              // CLONE MẢNG Ở ĐÂY để tránh lỗi unshift
              filteredData = [...listAccountantBranch];
            } else {
              filteredData = dataAccountant
                .filter(item => !item.isLocked)
                .map(item => ({ value: item.username, label: item.username }))
                .sort((a, b) => a.value.localeCompare(b.value, 'vi', { sensitivity: 'variant', caseFirst: 'upper' }));
            }

            updatedOptionsData = filteredData;
          } // Giả sử bạn đã định nghĩa thêm enum trong EModePanelSelect
          else if (selectedType === EModePanelSelect.WalletState) {
            updatedOptionsData = Object.entries(walletListState).map(([key, val]) => ({
              value: val, // Trả về 0, 1, 2, 3
              label: key === 'New' ? 'Chờ xác nhận' : key === 'Accept' ? 'Đã chấp nhận' : 'Bị từ chối'
              // Hoặc dùng: label: STATE_MAP[key] nếu bạn đã có object map tiếng Việt
            }));
          } else if (selectedType === EModePanelSelect.WalletStateTech) {
            updatedOptionsData = Object.entries(walletListStateTech).map(([key, val]) => ({
              value: val, // Trả về 0, 1, 2, 3
              label:
                key === 'Accepted'
                  ? 'Sẵn sàng'
                  : key === 'Return'
                  ? 'Đang trả kho'
                  : key === 'Exchange'
                  ? 'Đang trao đổi'
                  : key === 'Update'
                  ? 'Đang cập nhật'
                  : key === 'Undo'
                  ? 'Thu hồi sản phẩm'
                  : 'Đã sử dụng'
              // Hoặc dùng: label: STATE_MAP[key] nếu bạn đã có object map tiếng Việt
            }));
          } else if (selectedType === EModePanelSelect.AdjustmentTypes) {
            updatedOptionsData = adjustmentTypes.map(item => ({ value: item.type, label: item.displayName }));
          } else if (selectedType === EModePanelSelect.SupportBranch) {
            // Lấy từ API StaffAssignTag (danh sách chi nhánh được gán cho NV hiện tại)
            // Nếu chưa có dữ liệu (chưa fetch xong / trang khác không truyền) thì fallback về danh sách cứng cũ
            updatedOptionsData =
              supportBranchOptions && supportBranchOptions.length > 0
                ? [...supportBranchOptions]
                : [
                    { value: 'AD', label: 'Ánh Dương' },
                    { value: 'BM', label: 'Bình Minh' }
                  ];
          } else if (selectedType === EModePanelSelect.SupportState) {
            // Lấy từ API StaffAssignTag (danh sách tagId được gán cho NV hiện tại), map qua tên Tag thật
            updatedOptionsData =
              supportTagOptions && supportTagOptions.length > 0
                ? [...supportTagOptions]
                : dataCSKHType.map(item => ({ value: item.value, label: item.label }));
          } else if (selectedType === EModePanelSelect.WalletType) {
            updatedOptionsData = Object.entries(walletListType).map(([key, val]) => ({
              value: val, // Trả về 0, 1, 2
              label:
                key === 'Assign'
                  ? 'Cấp sản phẩm'
                  : key === 'Return'
                  ? 'Trả hàng'
                  : key === 'Update'
                  ? 'Yêu cầu cập nhật'
                  : key === 'Undo'
                  ? 'Thu hồi sản phẩm'
                  : 'Đổi hàng'
            }));
          } else if (selectedType === EModePanelSelect.Sender) {
            updatedOptionsData = techs
              .filter(
                accF =>
                  accF.companyBranchId == account.companyBranchId ||
                  account.listBranchManage?.find(brM => brM == accF.companyBranchId) ||
                  account.role == 'Admin' ||
                  account.role == 'Root'
              )
              .map(acc => ({
                value: acc.username,
                label: acc.username
              }));
          } else if (selectedType === EModePanelSelect.Receiver) {
            updatedOptionsData = techs
              .filter(
                accF =>
                  accF.companyBranchId == account.companyBranchId ||
                  account.listBranchManage?.find(brM => brM == accF.companyBranchId) ||
                  account.role == 'Admin' ||
                  account.role == 'Root'
              )
              .map(acc => ({
                value: acc.username,
                label: acc.username
              }));
          } else if (selectedType === EModePanelSelect.Stock) {
            updatedOptionsData = stocks.map(item => ({ value: item.Name, label: item.Name }));
          } else if (selectedType === EModePanelSelect.Order) {
            updatedOptionsData = [...orderArray];
          } else if (selectedType === EModePanelSelect.Customer) {
            updatedOptionsData = customer.map(item => ({ value: item.name, label: item.name }));
          } else if (selectedType === EModePanelSelect.Category) {
            updatedOptionsData = category.map(item => ({ value: item.name, label: item.name }));
          } else if (selectedType === EModePanelSelect.Branch) {
            updatedOptionsData = [...branch].map(Branchs => ({ label: Branchs.name, value: Branchs.id })) || [];
          } else if (selectedType === EModePanelSelect.BranchV2) {
            updatedOptionsData = [...branch].map(Branchs => ({ label: Branchs.name, value: Branchs.id })) || [];
          } else if (selectedType === EModePanelSelect.Status) {
            updatedOptionsData = statusOptions;
          } else if (selectedType === EModePanelSelect.CompanyName) {
            updatedOptionsData = dataOptionCompanyName.map(item => ({ value: item.value, label: item.label }));
          } else if (selectedType === EModePanelSelect.TypeCompany) {
            updatedOptionsData = dataOptionInvoice.map(item => ({ value: item.value, label: item.label }));
          } else if (selectedType === EModePanelSelect.CoopType) {
            updatedOptionsData = dataCoopType.map(item => ({ value: item.value, label: item.label }));
          } else if (selectedType === EModePanelSelect.OperateCollected) {
            updatedOptionsData = dataOperateCollected.map(item => ({ value: item.value, label: item.label }));
          } else if (selectedType === EModePanelSelect.AccountantCollected) {
            updatedOptionsData = dataAccountantCollected.map(item => ({ value: item.value, label: item.label }));
          } else if (selectedType === EModePanelSelect.CoopTypeV2) {
            updatedOptionsData = dataCoopType.map(item => ({ value: item.value, label: item.label }));
          } else if (selectedType === EModePanelSelect.TypeBranch) {
            updatedOptionsData = dataTypeBranch.map(item => ({ value: item.value, label: item.label }));
          } else if (selectedType === EModePanelSelect.IsBlock) {
            updatedOptionsData = dataBlock.map(item => ({ value: item.value, label: item.label }));
          } else if (selectedType === EModePanelSelect.Time) {
            updatedOptionsData =
              checkType === 'theodon' || checkType === 'kythuat' || checkType === 'dieuhanh' || checkType === 'congno'
                ? dataOptionAfterComplete.map(item => ({ value: item.value, label: item.label }))
                : dataOptionInputTime.map(item => ({ value: item.value, label: item.label }));
          } else if (selectedType === EModePanelSelect.ListSales) {
            updatedOptionsData = data
              .filter(item => !item.isLocked && item.role === 'Sale')
              .map(item => ({ value: item.username, label: item.username }))
              .sort((a, b) => a.value.localeCompare(b.value, 'vi', { sensitivity: 'variant', caseFirst: 'upper' }));
          } else if (selectedType === EModePanelSelect.ListSalesV2) {
            updatedOptionsData = dataSales
              .filter(item => !item.isLocked)
              .map(item => ({ value: item.username, label: item.username }))
              .sort((a, b) => a.value.localeCompare(b.value, 'vi', { sensitivity: 'variant', caseFirst: 'upper' }));
          } else if (selectedType === EModePanelSelect.ListSalesV3) {
            updatedOptionsData = dataSales
              .filter(item => !item.isLocked)
              .map(item => ({ value: item.username, label: item.username }))
              .sort((a, b) => a.value.localeCompare(b.value, 'vi', { sensitivity: 'variant', caseFirst: 'upper' }));
          } else if (selectedType === EModePanelSelect.PaymentMethod) {
            updatedOptionsData = dataHTTT.map(item => ({ value: item.value, label: item.label }));
          }

          if (isAllOption && updatedOptionsData.length !== 0) {
            if (
              selectedType !== EModePanelSelect.TechV2 &&
              selectedType !== EModePanelSelect.Time &&
              selectedType !== EModePanelSelect.TypeBranch &&
              selectedType !== EModePanelSelect.WalletStateTech
            ) {
              updatedOptionsData.unshift({
                value: '-1',
                label: t('Select.AllOption')
              });
            }
          } else {
            updatedOptionsData.unshift({
              value: '-1',
              label: t('Select.AllOption')
            });
          }

          let updateValueData: Array<string> = [];

          if (selectedType === EModePanelSelect.Tech) {
            updateValueData = t('Select.Init.Tech');
          } else if (selectedType === EModePanelSelect.TechV2) {
            updateValueData = t('Select.Init.Tech');
          } else if (selectedType === EModePanelSelect.Sender) {
            updateValueData = t('Select.Init.Sender');
          } else if (selectedType === EModePanelSelect.Receiver) {
            updateValueData = checkType === 'vikythuat' ? t('Select.Init.Tech') : t('Select.Init.Receiver');
          } else if (selectedType === EModePanelSelect.WalletState) {
            updateValueData = t('Select.Init.WalletState');
          } else if (selectedType === EModePanelSelect.WalletStateTech) {
            updateValueData = t('Select.Init.WalletState');
          } else if (selectedType === EModePanelSelect.WalletType) {
            updateValueData = t('Select.Init.WalletType');
          } else if (selectedType === EModePanelSelect.AdjustmentTypes) {
            updateValueData = t('Select.Init.AdjustmentTypes');
          } else if (selectedType === EModePanelSelect.SupportBranch) {
            updateValueData = t('Select.Init.SupportBranch');
          } else if (selectedType === EModePanelSelect.Operating) {
            updateValueData = t('Select.Init.Operating');
          } else if (selectedType === EModePanelSelect.Accountant) {
            updateValueData = t('Select.Init.Accountant');
          } else if (selectedType === EModePanelSelect.Staff) {
            updateValueData = t('Select.Init.Staff');
          } else if (selectedType === EModePanelSelect.Stock) {
            updateValueData = t('Select.Init.Stock');
          } else if (selectedType === EModePanelSelect.Order) {
            updateValueData = t('Select.Init.typeOrderData');
          } else if (selectedType === EModePanelSelect.Customer) {
            updateValueData = t('Select.Init.Customer');
          } else if (selectedType === EModePanelSelect.Category) {
            updateValueData = t('Select.Init.Category');
          } else if (selectedType === EModePanelSelect.Branch) {
            updateValueData = t('Select.Init.Branch');
          } else if (selectedType === EModePanelSelect.BranchV2) {
            updateValueData = t('Select.Init.Branch');
          } else if (selectedType === EModePanelSelect.Status) {
            updateValueData = t('Select.Init.Status');
          } else if (selectedType === EModePanelSelect.CompanyName) {
            updateValueData = t('Select.Init.CompanyName');
          } else if (selectedType === EModePanelSelect.TypeCompany) {
            updateValueData = t('Select.Init.TypeCompany');
          } else if (selectedType === EModePanelSelect.OperateCollected) {
            updateValueData = t('Select.Init.OperateCollected');
          } else if (selectedType === EModePanelSelect.AccountantCollected) {
            updateValueData = t('Select.Init.AccountantCollected');
          } else if (selectedType === EModePanelSelect.CoopType) {
            updateValueData = t('Select.Init.CoopType');
          } else if (selectedType === EModePanelSelect.CoopTypeV2) {
            updateValueData = t('Select.Init.CoopType');
          } else if (selectedType === EModePanelSelect.Time) {
            updateValueData = t('Select.Init.Time');
          } else if (selectedType === EModePanelSelect.ListSales) {
            updateValueData = t('Select.Init.ListSales');
          } else if (selectedType === EModePanelSelect.ListSalesV2) {
            updateValueData = t('Select.Init.ListSalesV2');
          } else if (selectedType === EModePanelSelect.ListSalesV3) {
            updateValueData = t('Select.Init.ListSales');
          } else if (selectedType === EModePanelSelect.PaymentMethod) {
            updateValueData = t('Select.Init.PaymentMethod');
          } else if (selectedType === EModePanelSelect.TypeBranch) {
            updateValueData = t('Select.Init.TypeBranch');
          }

          return (
            <>
              <Tooltip placement="top" title={updateValueData}>
                {!isHiddenDefaultSelect && <div className="separator" />}
                {!isMultipleSelect ? (
                  <SingleSelect
                    initial={updateValueData}
                    type={selectedType}
                    checkType={checkType}
                    isMutipleOrder={isMutipleOrder}
                    options={updatedOptionsData}
                    value={undefined}
                    defaultValue={
                      selectedType === EModePanelSelect.Time
                        ? 'TG Hoàn tất'
                        : selectedType === EModePanelSelect.TypeBranch
                        ? 'CN thực hiện'
                        : checkType === 'vikythuat'
                        ? 0
                        : '-1'
                    }
                    // onChange={note => handleSingleSelectChange(note, selectedType)}
                    minWidth={
                      selectedType === EModePanelSelect.Order
                        ? '250px'
                        : selectedType === EModePanelSelect.ListSalesV2 || selectedType === EModePanelSelect.CoopTypeV2
                        ? '200px'
                        : selectedType === EModePanelSelect.ListSalesV3 ||
                          selectedType === EModePanelSelect.Tech ||
                          selectedType === EModePanelSelect.Operating ||
                          selectedType === EModePanelSelect.Accountant ||
                          selectedType === EModePanelSelect.Sender ||
                          selectedType === EModePanelSelect.Receiver
                        ? '180px'
                        : selectedType === EModePanelSelect.WalletState ||
                          selectedType === EModePanelSelect.WalletStateTech ||
                          selectedType === EModePanelSelect.WalletType
                        ? '150px'
                        : '120px'
                    }
                  />
                ) : (
                  <MultipleSelect
                    initial={updateValueData}
                    type={selectedType}
                    options={updatedOptionsData}
                    value={multipleValue}
                    onChange={handleMultipleSelectChange}
                  />
                )}
              </Tooltip>
            </>
          );
        })}

        {/* sau đợt này khi rảnh là phải chuyển các cấu hình rời này vào sài chung với type select đã được cấu hình bên trên */}

        <div
          className={`flex items-center justify-center space-x-2 ${
            dealerStatisticFilter || type.length == 0 ? '' : ' mt-4'
          }`}
        >
          {checkType === 'khachhang' && (
            <Input
              type="text"
              addonBefore={allowSelect ? '' : selectBeforeV2}
              onChange={e => handleCustomerInputChange(e.target.value || '')}
              value={customerInputValue || ''}
              placeholder={
                selectedOptionV2 === 1
                  ? 'Tìm theo Mã khách hàng'
                  : selectedOptionV2 === 2
                  ? 'Tìm theo Tên đơn hàng'
                  : selectedOptionV2 === 3
                  ? 'Tìm theo Địa chỉ'
                  : selectedOptionV2 === 4
                  ? 'Tìm theo Email'
                  : selectedOptionV2 === 5
                  ? 'Tìm theo Số điện thoại'
                  : ''
              }
              style={{ width: checkType == 'khachhang' ? '300px' : '125px', height: '32px' }}
            />
          )}

          {checkType === 'sim' && (
            <div className="flex items-center gap-2">
              {/* Checkbox và nhãn */}
              <Checkbox checked={checkedSixMonth} onChange={e => setCheckedSixMonth(e.target.checked)}>
                Tìm trong 6 tháng gần nhất
              </Checkbox>

              {/* Input nhập số sim */}
              <Input
                placeholder="Nhập số sim"
                value={simInputValue || ''}
                onChange={e => handleSimInputChange(e.target.value)}
                style={{ width: 180 }}
              />

              {/* RangeDateJs (hoặc DateRangePicker) */}
              <div style={{ width: 280 }}>{renderDateTimeRangePicker}</div>

              {/* Nút xem */}
              {/* <Button type="primary" onClick={handleFilter} className="flex items-center justify-center">
                Xem
              </Button> */}
            </div>
          )}

          {checkType === 'hoadon' && (
            <Input
              type="text"
              addonBefore={allowSelect ? '' : selectBeforeV1}
              // Logic hiển thị Value
              value={
                selectedOptionV1 === 'orderCode'
                  ? customInputValue
                  : selectedOptionV1 === 'invoiceNo'
                  ? soHoaDonInputValue
                  : customerCustomInputValue // maKhachHang
              }
              // Sửa lỗi Logic tại đây: Map đúng Option với hàm Handle tương ứng
              onChange={e => {
                const val = e.target.value;
                // 1. Reset toàn bộ về rỗng trước
                setCustomInputValue('');
                setSoHoaDonInputValue('');
                setCustomerCustomInputValue('');

                if (selectedOptionV1 === 'orderCode') {
                  handleCustomInputChange(val);
                } else if (selectedOptionV1 === 'invoiceNo') {
                  handleSoHoaDonInputChange(val); // Trước đó bạn bị nhầm sang Customer
                } else if (selectedOptionV1 === 'customerCode') {
                  handleCustomerCustomInputChange(val); // Trước đó bạn bị nhầm sang SoHoaDon
                }
              }}
              placeholder={
                selectedOptionV1 === 'orderCode'
                  ? 'Nhập mã đơn hàng'
                  : selectedOptionV1 === 'invoiceNo'
                  ? 'Nhập số hóa đơn'
                  : 'Nhập mã khách hàng'
              }
              style={{ width: '300px', height: '32px' }}
            />
          )}

          {checkType === 'khokythuat' && (
            <Input
              type="text"
              addonBefore={selectBeforeV4}
              onChange={e => handleTransactionInputChange(e.target.value || '')}
              value={transactionInputValue || ''}
              placeholder={
                selectedOptionV4 === 'ProductCode'
                  ? 'Tìm theo Mã sản phẩm'
                  : selectedOptionV4 === 'PhoneOrSerial'
                  ? 'Tìm theo Serial-SĐT'
                  : ''
              }
              style={{ width: '300px', height: '32px' }}
            />
          )}

          {checkType === 'phieuhotro' && (
            <Input
              type="text"
              addonBefore={allowSelect ? '' : selectBeforeCSKH}
              // Logic hiển thị Value
              prefix={<SearchOutlined rev={''} className="site-form-item-icon text-gray-600" />}
              onChange={e => handleCSKHInputChange(e.target.value || '')}
              value={cskhInputValue || ''}
              onPressEnter={handleViewButton}
              placeholder={
                selectedOptionCSKH === 1
                  ? 'Tìm theo mã phiếu'
                  : selectedOptionCSKH === 2
                  ? 'Tìm theo SĐT, tên hoặc tài khoản khách'
                  : selectedOptionCSKH === 3
                  ? 'Tìm theo biển số xe'
                  : 'Tìm mã phiếu, khách hàng, biển số, SĐT'
              }
              style={{ width: '350px', height: '32px' }}
            />
          )}

          {/* ===== BẮT ĐẦU: filter riêng cho "Thống kê xe hết phí ở đại lý" (ThongKeHetPhi) =====
              Chỉ render khi có prop dealerStatisticFilter. Xoá an toàn: xoá cả block JSX này
              (không ảnh hưởng logic/JSX các trang khác đang dùng SelectPanel) cùng lúc với
              IDealerStatisticFilterProps, prop dealerStatisticFilter, callBackDealerStatisticFilter,
              đoạn trong handleViewButton, dòng 'thongkehetphi' trong hiddenInputTypes, và import
              AutoComplete (nếu không còn nơi nào khác trong file dùng). */}
          {dealerStatisticFilter && (
            <div className="flex flex-row flex-wrap gap-3 items-end">
              <div className="flex flex-col gap-1">
                <span className="text-xs font-semibold flex !flex-col">Tìm theo đại lý</span>
                <AutoComplete
                  style={{ width: 200, height: 32 }}
                  placeholder="Tìm đại lý..."
                  value={dealerStatisticFilter.dealerSearchValue}
                  options={dealerStatisticFilter.dealerSearchOptions.map(o => ({
                    value: o.name,
                    normalize: o.normalize
                  }))}
                  onSearch={dealerStatisticFilter.onDealerSearch}
                  onChange={dealerStatisticFilter.onDealerSearch}
                  onSelect={(value: string, option: any) =>
                    dealerStatisticFilter.onDealerSelect(value, option?.normalize)
                  }
                />
              </div>
              <div className="flex flex-col gap-1">
                <span className="text-xs font-semibold flex !flex-col">Tìm theo khu vực</span>
                <Select
                  mode="multiple"
                  showSearch
                  allowClear
                  placeholder="Khu vực"
                  style={{ minWidth: 140, height: 32 }}
                  value={dealerStatisticFilter.regionValue}
                  onChange={dealerStatisticFilter.onRegionChange}
                  options={dealerStatisticFilter.regionOptions}
                />
              </div>
              <div className="flex flex-col gap-1">
                <span className="text-xs font-semibold flex !flex-col">Tìm theo server</span>
                <Select
                  mode="multiple"
                  showSearch
                  allowClear
                  placeholder="Server"
                  style={{ minWidth: 140, height: 32 }}
                  value={dealerStatisticFilter.serverValue}
                  onChange={dealerStatisticFilter.onServerChange}
                  options={dealerStatisticFilter.serverOptions}
                />
              </div>
              <div className="flex flex-col gap-1">
                <span className="text-xs font-semibold flex !flex-col">Tìm theo loại TB</span>
                <Select
                  mode="multiple"
                  showSearch
                  allowClear
                  placeholder="Loại thiết bị"
                  style={{ minWidth: 140, height: 32 }}
                  value={dealerStatisticFilter.deviceTypeValue}
                  onChange={dealerStatisticFilter.onDeviceTypeChange}
                  options={dealerStatisticFilter.deviceTypeOptions}
                />
              </div>
            </div>
          )}
          {/* ===== KẾT THÚC block riêng ThongKeHetPhi ===== */}

          {shouldShowInput && (
            <Input
              type="text"
              addonBefore={allowSelect ? '' : selectBefore}
              value={
                selectedOption === 'OrderId'
                  ? customInputValue
                  : selectedOption === 'CustomerId'
                  ? customerCustomInputValue
                  : ''
              }
              onChange={e => {
                if (selectedOption === 'OrderId') handleCustomInputChange(e.target.value);
                else if (selectedOption === 'CustomerId') handleCustomerCustomInputChange(e.target.value);
              }}
              placeholder={selectedOption === 'OrderId' ? 'Nhập mã đơn hàng' : 'Nhập mã khách hàng'}
              style={{ width: inputWidth, height: '32px' }}
            />
          )}

          {/* keepTimeWhenHidden: luôn dựng ô ngày ở CÙNG 1 chỗ, chỉ đổi class ẩn / hiện (đổi chỗ thì React vẫn dựng lại -> reset) */}
          {keepTimeWhenHidden && <div className={hiddenTime ? 'hidden' : ''}>{renderDateTimeRangePicker}</div>}
          {!keepTimeWhenHidden && !hiddenTime && (
            <>
              {/* {dealerStatisticFilter ? (
                <div className="flex flex-col gap-1">
                  <span className="text-xs font-semibold flex !flex-col invisible">Tìm theo khu vực</span>
                  {renderDateTimeRangePicker}
                </div>
              ) : ( */}
              {renderDateTimeRangePicker}
              {/* )} */}
            </>
          )}

          <div className="lg:pl-2">
            {dealerStatisticFilter ? (
              <div className="flex flex-col gap-1">
                <span className="text-xs font-semibold flex !flex-col invisible">Tìm theo khu vực</span>
                <Button type={'primary'} onClick={handleViewButton}>
                  {t('Button.View')}
                </Button>
              </div>
            ) : (
              <Button type={'primary'} onClick={handleViewButton}>
                {t('Button.View')}
              </Button>
            )}
          </div>

          {showMoney && (
            <div className="lg:pl-2">
              <Button
                type={'primary'}
                disabled={isDisableConfirm}
                onClick={handleOpenModal}
                className={`
                  relative flex items-center justify-center gap-2
                  font-medium transition-all
                  ${
                    isDisableConfirm
                      ? 'bg-gray-50  cursor-not-allowed'
                      : 'bg-emerald-600 text-white hover:bg-emerald-500 hover:shadow-lg active:opacity-90'
                  }
              `}
              >
                {'Thu tiền'} ({selectedRowKeys.length})
              </Button>
            </div>
          )}
        </div>
      </div>
      {/* phần select 2 */}

      {/* <div className="flex flex-row space-x-2 lg:w-[100%]">
        {renderDateTimeRangePicker}
        {checkType !== 'tongquanKD' && checkType !== 'tongquan' && (
          <Input
            type="text"
            addonBefore={allowSelect ? '' : selectBefore}
            value={
              selectedOption === 'OrderId'
                ? customInputValue
                : selectedOption === 'CustomerId'
                ? customerCustomInputValue
                : ''
            }
            onChange={e =>
              selectedOption === 'OrderId'
                ? handleCustomInputChange(e.target.value)
                : selectedOption === 'CustomerId'
                ? handleCustomerCustomInputChange(e.target.value)
                : null
            }
            placeholder={selectedOption === 'OrderId' ? 'Nhập mã đơn hàng' : 'Nhập mã khách hàng'}
            style={{ width: checkType == 'theodon' ? '300px' : '125px', height: '32px' }}
          />
        )}

        <div className="lg:pl-2">
          <Button type={'primary'} onClick={handleViewButton}>
            {t('Button.View')}
          </Button>
        </div>
      </div> */}
    </div>
  );
};
